export enum AccordanceType {
  Revision = 1,
  Monitoring,
  InterGroup,
  PreparationForStart,
  StartPreparation,
  ThermalMediumMonitoring,
  PreparationForClosing
}
